import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { TemplatePdfService } from "@/modules/TemplatePdf/services/templatePdfService";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GENERATE_PDF_CONSTANTS,
  LABELS_GENERATE_PDF,
  METHODS,
  MINUSHEIGHT,
  RENDER_OPTIONS
} from "../../constants/generate-pdf.contants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  GENERAL_CONSTANTS,
  OPTIONS_LOCALE_DATE
} from "@/shared/constants/GeneralConstants";
import { Service } from "@/modules/Services/models/Service";
import { FieldUser } from "@/modules/User/models/FieldUser";
import { FormsService } from "@/modules/Forms/services/FormService";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import FormSummaryPreview from "@/shared/components/FormModalViewer/FormSummaryPreview/FormSummaryPreview.vue";
import { FormDetailsModel } from "./model/PreviewPdf.model";
import { TemplatePdf } from "@/modules/TemplatePdf/Models/templatePdf";
import jsPDF from "jspdf";
import "firebase/storage";
import firebase from "firebase/app";
import { DocumentService } from "@/modules/Document/services/DocumentService";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import { Http } from "@status/codes";
import { Utils } from "@/shared/utils/utils";
import { FILE } from "@/shared/constants/FileConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { DOCUMENTS_ACCESS } from "@/modules/Document/constants/DocumentConstants";
import { TEMPLATE_PDF_ACCESS } from "@/modules/TemplatePdf/constants/TemplatePdfConstants";
import { FORMS_ACCESS } from "@/modules/Forms/constants/FormsConstants";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
// @ts-expect-error
import * as pdfMake from "pdfmake/build/pdfmake";
// @ts-expect-error
import * as pdfFonts from "pdfmake/build/vfs_fonts";

@Component({
  name: "PreviewPdf",
  components: {
    FormSummaryPreview
  }
})
export default class PreviewPdf extends Vue {
  @Inject() templatePdfService!: TemplatePdfService;
  @Inject() formsService!: FormsService;
  @Inject() documentService!: DocumentService;
  @Inject() servicesService!: ServicesService;

  @Prop() private templatePdfId!: string;
  @Prop() public choosenFieldsPatient!: FieldUser[];
  @Prop() public choosenFieldsDoctor!: FieldUser[];
  @Prop() public formsSelected!: SectionGroupDetail[];
  @Prop() public fieldsSelected!: { [form: string]: string[] };
  @Prop() public service!: Service;
  @Prop() private userId!: string;
  @Prop({ default: false }) public dialog!: boolean;

  cardClass = STYLE_CLASSES.CARD;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  bussinessDetailsShow: string[] = [];
  serviceDate = "";
  printDate = new Date().toLocaleDateString("es-CO", OPTIONS_LOCALE_DATE);
  serviceInformation: FormDetailsModel[] = [];
  width = 0;
  height = 0;
  doc!: jsPDF;
  loading = false;
  fieldName = "";
  multimediaId = "";
  header = new Blob();
  footer = new Blob();
  loadingPdf = false;

  TITLE = GENERATE_PDF_CONSTANTS.TITLES.PREVIEW_TITLE;
  CANCEL_BTN = GENERATE_PDF_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = GENERATE_PDF_CONSTANTS.BUTTON.SAVE_PDF;
  RENDER_OPTIONS: { [key: string]: string } = RENDER_OPTIONS;
  LABELS = LABELS_GENERATE_PDF;
  loadHeader = false;
  loadFooter = false;

  async mounted() {
    this.serviceDate = new Date(this.service.dateCreated!)?.toLocaleDateString(
      "es-CO",
      OPTIONS_LOCALE_DATE
    );
    this.doc = new jsPDF({
      orientation: "p",
      unit: "px",
      format: "a4",
      hotfixes: ["px_scaling", "scale_text", "fill_close"],
      precision: 0
    });
    this.width = this.doc.internal.pageSize.width;
    this.height = this.doc.internal.pageSize.height - MINUSHEIGHT;
    this.getDataSections();
    await this.getDataTemplatePdf();
  }

  toDataURL(url: string, callback: CallableFunction) {
    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
      const reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  async createDocument() {
    try {
      const response = await this.documentService.createDocumentRecord({
        fileName: `${LABELS_GENERATE_PDF.CLINICAL_CONSULTATION} ${this.service.internalName}`,
        type: "pdf",
        userId: this.userId
      });
      if (response.code !== Http.Ok) {
        return Snackbar.popError(
          GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_SAVE_PDF
        );
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DOCUMENTS_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async updateDocument(multimediaPath: string, multimediaId: string) {
    const response = await this.documentService.updateDocumentPath({
      storagePath: multimediaPath,
      documentId: multimediaId
    });
    if (response.code !== Http.Ok) {
      return Snackbar.popError(GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_SAVE_PDF);
    }
    return true;
  }

  async uploadFile(fieldName: string, blob: any) {
    const storageRef = firebase.storage().ref();
    const response = await storageRef
      .child(
        `${Utils.getClientStoragePath()}/${FILE.FILE_STORAGE_FOLDER}/${
          this.userId
        }/${fieldName}.pdf`
      )
      .put(blob);

    if (response) {
      const downloadURL = (await response.ref.getDownloadURL()).toString();
      this.loading = false;
      await this.updateDocument(downloadURL, fieldName);
      await this.servicesService.updateDocument(this.service.id!, fieldName);
      this.cancel(false);
      this.$emit(METHODS.REFRESH_DATA);
      Snackbar.popSuccess(GENERATE_PDF_CONSTANTS.MESSAGES.SAVE_PDF);
    } else {
      throw new Error(GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_SAVE_PDF);
    }
  }

  async makePdf() {
    try {
      this.loading = true;
      const multimediaId = (await this.createDocument()) as string;
      if (!multimediaId) {
        this.loading = false;
        return;
      }

      const docDefinition = {
        header: {
          stack: [
            {
              image: this.header,
              width: 100,
              fit: [100, 100],
              alignment: "center",
              margin: [0, 10, 0, 10] // Espaciado superior e inferior del logo
            },
            {
              text: "Información de la empresa",
              style: "headerText",
              alignment: "center",
              margin: [0, 10, 0, 0] // Espaciado adicional entre el logo y el texto
            }
          ]
        },
        footer: {
          stack: [
            {
              image: this.footer,
              width: 100,
              fit: [100, 100],
              alignment: "center",
              margin: [0, 10, 0, 10] // Espaciado superior e inferior del logo
            },
            {
              text: "Información del footer",
              style: "headerText",
              alignment: "center",
              margin: [0, 10, 0, 0] // Espaciado adicional entre el logo y el texto
            }
          ]
        },
        content: this.buildPdfContent(),
        pageSize: "A4",
        pageMargins: [40, 100, 40, 100], // Aumenta el margen para que el contenido no colisione con el header/footer
        styles: {
          headerText: {
            fontSize: 12, // Puedes ajustar el tamaño si es necesario
            alignment: "center"
          },
          table: {
            fillColor: "#EBE8E7",
            width: "100%"
          }
        }
      };
      (pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;
      const pdf = pdfMake.createPdf(docDefinition as any);

      pdf.getBlob((blob: any) => {
        this.uploadFile(multimediaId, blob);
        this.loading = false;
      });
    } catch (error) {
      this.loading = false;
      Snackbar.popError(GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_SAVE_PDF);
    }
  }

  buildPdfContent() {
    let fieldsForms: any = [];
    const tableLayout = {
      defaultBorder: false,
      paddingLeft: function() {
        return 8;
      },
      paddingRight: function() {
        return 8;
      },
      paddingTop: function() {
        return 8;
      },
      paddingBottom: function() {
        return 8;
      }
    };

    fieldsForms.push({
      text: this.bussinessDetailsShow
        .filter(data => data !== RENDER_OPTIONS.logo)
        .join("  •  "),
      style: "headerText",
      fontSize: 10
    });
    fieldsForms.push({
      columns: [
        {
          width: "50%",
          text: `${this.LABELS.SERVICE_DATE} ${this.serviceDate}`
        },
        {
          width: "50%",
          text: `${this.LABELS.PRINT_DATE} ${this.printDate}`
        }
      ]
    });

    const doctorFields = this.defaultForms(
      this.choosenFieldsDoctor,
      tableLayout,
      this.LABELS.DOCTOR_INFO
    );

    if (doctorFields.length > 0) {
      fieldsForms = [...fieldsForms, ...doctorFields];
    }

    const patientFields = this.defaultForms(
      this.choosenFieldsPatient,
      tableLayout,
      this.LABELS.PATIENT_INFO
    );

    if (patientFields.length > 0) {
      fieldsForms = [...fieldsForms, ...patientFields];
    }

    for (const form of this.serviceInformation) {
      const formFields = [];
      let cont = 1;
      let rowFormFields = [];

      for (const [index, obj] of form.fields!.entries()) {
        rowFormFields.push(`${obj.title}: ${obj.value![0]}`);
        if (cont % 3 === 0) {
          formFields.push(rowFormFields);
          rowFormFields = [];
        }

        if (form.fields?.length === index + 1 && rowFormFields.length < 3) {
          Array(3 - rowFormFields.length)
            .fill("")
            .forEach(() => {
              rowFormFields.push("");
            });
          formFields.push(rowFormFields);
        }
        cont++;
      }

      fieldsForms.push({ text: form.name, margin: [0, 20, 0, 10], bold: true });
      fieldsForms.push({
        text: this.getSummary(form.formSummary),
        margin: [0, 20, 0, 10],
        bold: false
      });
      if (formFields.length > 0) {
        const newForm = {
          table: {
            body: formFields
          },
          layout: tableLayout,
          style: "table"
        };
        fieldsForms.push(newForm);
      }
    }
    return fieldsForms;
  }

  defaultForms(
    fieldOfTheForm: FieldUser[],
    tableLayout: any,
    infoLabel: string
  ) {
    const fields = [];
    let cont = 1;
    let rowFields = [];
    for (const field of fieldOfTheForm) {
      rowFields.push(`${field.title}: ${field.value}`);
      if (cont % 3 === 0) {
        fields.push(rowFields);
        rowFields = [];
      }
      cont++;
    }

    if (fields.length > 0) {
      const newForm = {
        table: {
          body: fields
        },
        layout: tableLayout,
        style: "table"
      };
      return [{ text: infoLabel, margin: [0, 20, 0, 10], bold: true }, newForm];
    }
    return [];
  }

  async getDataSections() {
    try {
      this.loadingPdf = true;
      const promises = this.formsSelected.map(form => {
        const query = {
          formTemplateId: form.id,
          formId: form.form,
          loadData: false
        };

        return this.formsService.formServiceInformation(query).then(
          response =>
            (({
              ...form,
              model: response.data?.form.fields,
              formSummary: response.data?.schemaData?.formSummary
            } as unknown) as FormDetailsModel)
        );
      });
      const responses = await Promise.all(promises);

      responses.forEach((form: FormDetailsModel) => {
        const fieldsForm = this.fieldsSelected[form.form!];

        if (!fieldsForm) return;

        const fieldSelecteds: any[] = [];
        fieldsForm.forEach((field: string) => {
          if (form.fields) {
            fieldSelecteds.push(form.fields[field as any]);
          }
        });

        this.serviceInformation.push({
          ...form,
          fields: fieldSelecteds as any
        });
      }) as any;
      this.loadingPdf = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORMS_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_SERVICE;

      Snackbar.popError(errorMessage);
    }
  }

  async getDataTemplatePdf() {
    try {
      const response = await this.templatePdfService.getTemplateById(
        this.templatePdfId
      );
      if (response.code !== Http.Found) {
        return Snackbar.popError(
          GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_DETAIL_TEMPLATE_PDF
        );
      }
      (response.data as TemplatePdf)?.businessDetails.forEach(detail => {
        const [[name, value]] = Object.entries(detail);
        if (value) this.bussinessDetailsShow.push(this.RENDER_OPTIONS[name]);
      });

      this.toDataURL(
        (response.data as TemplatePdf)?.multimediaHeader?.multimediaPath!,
        (imageconverted: Blob) => {
          this.header = imageconverted;

          this.loadHeader = true;
        }
      );

      this.toDataURL(
        (response.data as TemplatePdf)?.multimediaFooter?.multimediaPath!,
        (imageconverted: Blob) => {
          this.footer = imageconverted;

          this.loadFooter = true;
        }
      );
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TEMPLATE_PDF_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_DETAIL_TEMPLATE_PDF;

      return Snackbar.popError(errorMessage);
    }
  }

  cancel(open: boolean) {
    this.$emit(METHODS.CLOSE_PREVIEW, true);
    if (open) {
      this.$emit(METHODS.OPEN_MODAL);
    }
  }

  getSummary(formSummary: FieldSummary[]) {
    let formTextSummary = "";
    formSummary.forEach((fieldSummary: FieldSummary) => {
      if (fieldSummary.summary && fieldSummary.field != undefined) {
        formTextSummary = `${formTextSummary}${fieldSummary.summaryText}`;
      }
    });
    formTextSummary = formTextSummary.substring(0, formTextSummary.length - 2);
    formTextSummary = `${formTextSummary}.`;
    return formTextSummary;
  }
}
